"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavItem = NavItem;
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const useStyles = (0, react_jss_1.createUseStyles)({
    navBarItem: {
        "padding": "16px 0",
        "fontSize": "24px",
        "@media (min-width: 412px)": {
            padding: "16px 0",
            fontSize: "32px",
        },
        "color": "#fff",
        "background": "#171717",
        "flex": "1",
        "border": "none",
        "outline": "none",
        "&:not(:last-child)": {
            borderRight: "3px solid #3c3c3c",
        },
        "position": "relative",
    },
    navBarItemActive: {
        textDecoration: "underline",
        background: "#3c3c3c",
    },
});
function NavItem({ isActive, icon, children, onClick }) {
    const styles = useStyles();
    return (react_1.default.createElement("button", { className: (0, classnames_1.default)(styles.navBarItem, {
            [styles.navBarItemActive]: isActive,
        }), onClick: onClick },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon }),
        children));
}
